import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

const ItemCell = (params: ICellRendererParams) => {
  const label = params.valueFormatted ?? params.value;
  const shipWindowCount: number = params.data?.shipWindowCount ?? 0;
  if (shipWindowCount <= 1) return <span>{label}</span>;

  return (
    <span className="px-po-clearing-item-cell">
      <span className="px-po-clearing-item-label">{label}</span>
      <span className="px-po-clearing-ship-windows-badge">
        <span className="px-po-clearing-ship-windows-divider">&#8214;</span>
        {`${shipWindowCount} Ship Windows`}
      </span>
    </span>
  );
};

export default ItemCell;
